import { validateQrisPayload } from "./qris";

const MAX_DECODE_SIZE = 1800;

const loadImageElement = (file) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Gambar QRIS tidak dapat dibuka."));
    };
    image.src = objectUrl;
  });

export const decodeQrisImageFile = async (file) => {
  if (!(file instanceof File)) {
    throw new Error("Pilih file gambar QRIS terlebih dahulu.");
  }

  const image = await loadImageElement(file);
  const scale = Math.min(1, MAX_DECODE_SIZE / Math.max(image.naturalWidth, image.naturalHeight));
  const width = Math.max(1, Math.round(image.naturalWidth * scale));
  const height = Math.max(1, Math.round(image.naturalHeight * scale));
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d", { willReadFrequently: true });

  if (!context) {
    throw new Error("Pemindai QRIS tidak didukung browser ini.");
  }

  canvas.width = width;
  canvas.height = height;
  context.drawImage(image, 0, 0, width, height);

  const imageData = context.getImageData(0, 0, width, height);
  const { default: jsQR } = await import("jsqr");
  const result = jsQR(imageData.data, width, height, { inversionAttempts: "attemptBoth" });
  const payload = String(result?.data || "").trim();

  if (!payload) {
    throw new Error("QR tidak terbaca. Gunakan gambar QRIS yang tajam, utuh, dan tidak terpotong.");
  }

  validateQrisPayload(payload);
  return payload;
};
